import React, { useState } from "react";
import { Box, Typography, Stack, capitalize } from "@mui/material";
import MusicCard from "../../components/MusicCard";
import { useParams, useLocation } from "react-router-dom";
import "./index.scss";
import PageHeader from "../../components/PageHeader";
import NoData from "../../components/Nodata";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { addSongAction, addSongsAction } from "./../../action/songs";

import ApiService from "./../../services/api-service";
import Loader from "./../../components/Loader";
import notifier from "./../../components/Notifier";
import {
  getErrorString,
  isOwner,
  isOwnerId,
  getWords,
} from "./../../constants/function";
import AddMusicToPlaylist from "../../components/AddMusicToPlaylist";
import Back from "../../components/Back";
import { useTranslation } from "react-i18next";
import { startStream } from "../../action/stream";
export default function ExploreMore(props) {
  const { isStream } = useSelector((state) => state.stream);
  const [message, setMessage] = React.useState(null);
  const { t } = useTranslation("common");
  const [pageNo, setPageNo] = React.useState(1);
  const [loaded, setLoaded] = React.useState(false);
  const history = useHistory();
  const { id } = useParams(props);
  const [isFeature, setFeature] = React.useState(false);
  const [isOther, setIsOther] = React.useState(false);
  const { state } = useLocation();
  const dispatch = useDispatch();
  const [selectedIndex, setSelectedIndex] = React.useState(null);
  const [selectedId, setSelectedAlbum] = React.useState();
  const [isArtist, setArtist] = React.useState(false);
  const [music, setMusic] = React.useState([]);
  const [loading, setLoading] = useState(false);
  const [showPlaylist, setShowPlaylist] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [isMusic, setIsMusic] = React.useState(false);
  const [isPlaylist, setIsPlaylist] = React.useState(false);
  const toggleDrawer = (value, id, index, music) => {
    setOpen(value);
    setSelectedIndex(index);
    setSelectedAlbum(id);
    if (value && id) {
      setOpen(false);
      makeAction(value, id, index, music);
    }
  };
  const makeAction = async (key, id, index, song) => {
    switch (key) {
      case "m2":
        if (
          !isOwnerId(
            song["owner"] && typeof song["owner"] === "string"
              ? song["owner"]
              : song["uploader"] && typeof song["uploader"] === "string"
              ? song["uploader"]
              : ""
          ) &&
          song["private"] &&
          !song["isSubscribed"]
        )
          notifier.error(t("notifier.error.toast5"));
        else if (
          (typeof song["owner"] === "object" ||
            typeof song["uploader"] === "object") &&
          !isOwnerId(
            song["owner"]
              ? song["owner"]["_id"]
              : song["uploader"]
              ? song["uploader"]["_id"]
              : ""
          ) &&
          song["private"] &&
          ((song["owner"] && !song["owner"]["isSubscribed"]) ||
            (song["uploader"] && !song["uploader"]["isSubscribed"]))
        )
          notifier.error(t("notifier.error.toast5"));
        else {
          dispatch(addSongAction(song, null, true));
        }
        break;
      case "m3":
        if (
          !isOwnerId(
            song["owner"] && typeof song["owner"] === "string"
              ? song["owner"]
              : song["uploader"] && typeof song["uploader"] === "string"
              ? song["uploader"]
              : ""
          ) &&
          song["private"] &&
          !song["isSubscribed"]
        )
          notifier.error(t("notifier.error.toast5"));
        else if (
          (typeof song["owner"] === "object" ||
            typeof song["uploader"] === "object") &&
          !isOwnerId(
            song["owner"]
              ? song["owner"]["_id"]
              : song["uploader"]
              ? song["uploader"]["_id"]
              : ""
          ) &&
          song["private"] &&
          ((song["owner"] && !song["owner"]["isSubscribed"]) ||
            (song["uploader"] && !song["uploader"]["isSubscribed"]))
        )
          notifier.error(t("notifier.error.toast5"));
        // handleClose();
        else setShowPlaylist(true);
        break;
      case "m1":
        history.push(
          song?.nftId
            ? `/app/SongDetail/${song?.nftId}`
            : `/app/SongDetails/${id}`
        );
        break;
      case "m29":
        history.push(`/app/ArtistProfile/${id}`);
        break;
      case "m26":
        if (
          !isOwnerId(
            song["createdBy"]
              ? song["createdBy"]
              : song["createdByDetails"]
              ? song["createdByDetails"]["_id"]
              : ""
          ) &&
          song["private"] &&
          ((song["createdByDetails"] &&
            !song["createdByDetails"]["isSubscribed"]) ||
            (song["createdByDetails"] &&
              !song["createdByDetails"]["isSubscribed"]))
        )
          notifier.error(t("notifier.error.toast5"));
        else {
          const tempMusic = await getPlayListMusic(id);
          dispatch(addSongsAction(tempMusic, false, isPlaylist ? id : null, 0));
        }

        break;
      case "m27":
        history.push(`/app/PlaylistStatics/${id}/${music[index]["createdBy"]}`);
      default:
        break;
    }
  };
  const getPlayListMusic = async (_id) => {
    try {
      setLoading(true);
      const response = await ApiService.PLAYLIST_DETAIL({
        _id: _id,
        pageNo: 1,
        pageSize: 100,
      });

      setLoading(false);

      return response["result"]["music"] || [];
    } catch (error) {
      setLoading(false);

      notifier.error(getErrorString(error));
      return [];
    }
  };
  React.useEffect(() => {
    setMusic([]);
    setIsMusic(
      id === "music" ||
        id === "NewRelease" ||
        id === "MostStreamToday" ||
        id === "MostStreamThisWeek" ||
        id === "MostTipped" ||
        history.location.pathname.includes("searchMusic")
        ? true
        : false
    );
    setIsPlaylist(
      id === "studios" ||
        id === "NowLive" ||
        history.location.pathname.includes("searchStudio") ||
        history.location.pathname.includes("MostTippedStudio") ||
        history.location.pathname.includes("MostStreamed") ||
        history.location.pathname.includes("NewReleaseStudio") ||
        history.location.pathname.includes("MostStreamedTodayStudio") ||
        history.location.pathname.includes("MostStreamedThisWeekStudio")
        ? true
        : false
    );
    if (history.location.pathname.includes("searchMusic"))
      getSearchedMusic(id, pageNo);
    else if (history.location.pathname.includes("searchStudio"))
      handlePlaylistSearch(id, pageNo);
    else if (history.location.pathname.includes("searchArtist"))
      handleUserSearch(id, pageNo);
    else {
      switch (id) {
        case "music":
          setFeature(true);
          getFeatureMusic(pageNo);
          break;
        case "artists":
          setFeature(true);
          getFeatureArtist();
          break;
        case "studios":
          setFeature(true);
          getFeaturePlaylist();
          break;
        case "users":
          setFeature(true);
          getFeatureUser();
          break;
        case "NewRelease":
          setIsOther(true);
          getNewrelease();
          break;
        case "NowLive":
          setIsOther(true);
          getLiveStreams(pageNo);
          break;
        case "MostStreamToday":
          setIsOther(true);
          getmoststreamtoday();
          break;
        case "MostStreamThisWeek":
          setIsOther(true);
          getmoststreamthisweek();
          break;
        case "MostTipped":
          setIsOther(true);
          getmosttipped();
          break;
        case "MostTippedStudio":
          setIsOther(true);
          getmosttippedPlaylist();
          break;
        case "MostStreamed":
          setIsOther(true);
          getmostStreamedPlaylist();
          break;
        case "NewReleaseStudio":
          setIsOther(true);
          getNewReleasePlaylist();
          break;
        case "MostStreamedTodayStudio":
          setIsOther(true);
          getMostStreamedTodayPlaylist();
          break;
        case "MostStreamedThisWeekStudio":
          setIsOther(true);
          getMostStreamedThisWeekPlaylist();
          break;
        case "mostexpensivenft":
          setIsOther(true);
          getmostexpensive();
          break;
        case "playlistmostexpensive":
          setIsOther(true);
          getplaylistmostexpensive();
          break;
        case "leastexpensive":
          setIsOther(true);
          getleastexpensive();
          break;
        case "playlistleastexpensive":
          setIsOther(true);
          getplaylistleastexpensive();
          break;
        case "ownerpercentage":
          setIsOther(true);
          getownerpercentage();
          break;
        case "endingsoonauction":
          setIsOther(true);
          getendingsoonauction();
          break;
        default:
          break;
      }
    }
  }, [history.location.pathname]);
  const handleUserSearch = async (keyword, next) => {
    if (keyword) {
      try {
        setLoading(true);
        const response = await ApiService.SEARCH_USER(
          `${keyword}&pageSize=16&pageNo=${next}`
        );
        setLoaded(response["result"].length < 15 ? true : false);
        setMusic((preData) => [...preData, ...response["result"]]);
        setLoading(false);
      } catch (error) {
        console.error(error);
        setLoading(false);
      }
    }
  };
  const handlePlaylistSearch = async (keyword, next) => {
    if (keyword) {
      try {
        setLoading(true);
        const response = await ApiService.SEARCH_PLAYLIST(
          `${keyword}&pageNo=${next}&pageSize=16`
        );
        setLoaded(response["result"].length < 15 ? true : false);
        setMusic((prevStudio) => [...prevStudio, ...response["result"]]);
        setLoading(false);
      } catch (error) {
        console.error(error);
        setLoading(false);
      }
    }
  };
  const getFeatureMusic = async (next) => {
    try {
      setLoading(true);
      const response = await ApiService.FEATURE_MUSIC(`pageSize=16`);
      setMusic([...response["result"]]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  const getSearchedMusic = async (id, next) => {
    if (id) {
      try {
        setLoading(true);
        const response = await ApiService.SEARCH_MUSIC(
          `${id}&pageNo=${next}&pageSize=16`
        );
        setLoaded(response["result"].length < 15 ? true : false);
        setMusic((prevMusic) => [...prevMusic, ...response["result"]]);
        setLoading(false);
      } catch (error) {
        console.error(error);
        setLoading(false);
      }
    }
  };
  const getFeatureUser = async () => {
    try {
      setLoading(true);
      const response = await ApiService.FEATURE_USER("&pageSize=16");
      setMusic([...response["result"]]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  const getNewrelease = async () => {
    try {
      setLoading(true);
      const response = await ApiService.MUSIC_NEW_RELEASE();
      setMusic([...response["result"]]);
      console.log("response", response);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  const getmoststreamtoday = async () => {
    try {
      setLoading(true);
      const response = await ApiService.MUSIC_MOST_STREAM_TODAY();
      setMusic([...response["result"]]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  const getmoststreamthisweek = async () => {
    try {
      setLoading(true);
      const response = await ApiService.MUSIC_MOST_STREAM_WEEK();
      setMusic([...response["result"]]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  const getmostStreamedPlaylist = async () => {
    try {
      setLoading(true);
      const response = await ApiService.PLAYLIST_STREAMED();
      setMusic([...response["result"]]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  const getNewReleasePlaylist = async () => {
    try {
      setLoading(true);
      const response = await ApiService.PLAYLIST_NEW_RELEASE();
      setMusic([...response["result"]]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  const getMostStreamedTodayPlaylist = async () => {
    try {
      setLoading(true);
      const response = await ApiService.PLAYLIST_MOST_STREAMED();
      setMusic([...response["result"]]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  const getMostStreamedThisWeekPlaylist = async () => {
    try {
      setLoading(true);
      const response = await ApiService.PLAYLIST_STREAMED_LASTWEEK();
      setMusic([...response["result"]]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  const getmosttippedPlaylist = async () => {
    try {
      setLoading(true);
      const response = await ApiService.PLAYLIST_MOST_TIPPED();
      setMusic([...response["result"]]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  const getmosttipped = async () => {
    try {
      setLoading(true);
      const response = await ApiService.MUSIC_MOST_TIPPED();
      setMusic([...response["result"]]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };

  const getFeatureArtist = async () => {
    try {
      setLoading(true);
      const response = await ApiService.FEATURE_ARTIST("&pageSize=16");
      setMusic([...response["result"]]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  const getFeaturePlaylist = async () => {
    try {
      setLoading(true);
      const response = await ApiService.FEATURE_PLAYLIST("&pageSize=16");
      setMusic([...response["result"]]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };

  const getmostexpensive = async () => {
    try {
      setLoading(true);
      const response = await ApiService.MOSTEXPENSIVE();
      setMusic([...response["result"]]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  const getplaylistmostexpensive = async () => {
    try {
      setLoading(true);
      const response = await ApiService.PLAYLISTMOSTEXPENSIVE();
      setMusic([...response["result"]]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  const getleastexpensive = async () => {
    try {
      setLoading(true);
      const response = await ApiService.LEASTEXPENSIVE();
      setMusic([...response["result"]]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  const getplaylistleastexpensive = async () => {
    try {
      setLoading(true);
      const response = await ApiService.PLAYLISTLEASTEXPENSIVE();
      setMusic([...response["result"]]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  const getownerpercentage = async () => {
    try {
      setLoading(true);
      const response = await ApiService.OWNERPERCENTAGE();
      setMusic([...response["result"]]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  const getendingsoonauction = async () => {
    try {
      setLoading(true);
      const response = await ApiService.ENDINGSOONAUCTION();
      setMusic([...response["result"]]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  const getLiveStreams = async (next) => {
    try {
      setLoading(true);
      const response = await ApiService.LIVESTREAM(
        `?pageNo=${next}&pageSize=16`
      );
      setLoaded(response["result"].length < 15 ? true : false);
      setMusic([...music, ...response["result"]]);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  const playSongs = (songs, index) => {
    if (songs.length > 0) dispatch(addSongsAction(songs, false, null, index));
  };
  const handleScroll = async (target) => {
    var a = target.scrollTop;
    var b = target.scrollHeight - target.clientHeight;

    if ((a / b) * 100 > 80 && !loading && !loaded) {
      // run a function called doSomething
      const next = pageNo + 1;
      setPageNo(next);
      if (history.location.pathname.includes("searchMusic"))
        getSearchedMusic(id, next);
      else if (history.location.pathname.includes("searchStudio"))
        handlePlaylistSearch(id, next);
      else if (history.location.pathname.includes("searchArtist"))
        handleUserSearch(id, next);
      else if (history.location.pathname.includes("NowLive"))
        getLiveStreams(next);
    }
  };
  const handleClick = (channelName) => {
    getPlaylistDetail(channelName);
  };
  const getPlaylistDetail = async (channelName) => {
    if (!isStream) {
      try {
        setLoading(true);
        setMessage(t("loader.message14"));
        const response = await ApiService.PLAYLIST_DETAIL({
          _id: channelName,
          pageNo: 1,
          pageSize: 1,
        });
        if (!response?.result?.live) {
          setLoading(false);
          setMessage(null);
          notifier.error(t("notifier.error.toast3"));

          return;
        }
        if (
          response?.result?.live &&
          !response?.result?.isSubscribed &&
          response?.result?.private
        ) {
          setLoading(false);
          setMessage(null);
          notifier.error(t("notifier.error.toast4"));

          return;
        }
        const status = await getBlockedUserOfPlaylist(channelName);
        if (typeof status === "boolean" && status) {
          notifier.error(t("notifier.error.toast2"));
          setLoading(false);
          return;
        }
        dispatch(
          startStream({
            streamData: response?.result,
            title: null,
            goal: null,
            goalDescription: null,
          })
        );
        setLoading(false);
        setMessage(null);
      } catch (error) {
        if (
          getErrorString(error) ===
          "This is an explicit content you need to be above 18 to view it"
        ) {
          notifier.error(getErrorString(error));
        }
        setLoading(false);
        setMessage(null);
      }
    } else notifier.warning("You have already joined a live stream");
  };
  const getBlockedUserOfPlaylist = async (roomid) => {
    try {
      const response = await ApiService.BLOCKER_USER(roomid);
      return response?.result?.isBlocked;
    } catch (error) {
      return null;
    }
  };
  return (
    <Box
      sx={{ paddingBottom: "100px", maxHeight: "90%", overflow: "scroll" }}
      onScroll={(e) => handleScroll(e.target)}
    >
      <Back />
      <Box className="__main_pading" sx={{ paddingBottom: "80px" }}>
        <Typography className="fs-20">
          {isFeature
            ? `${t("feature")} ${capitalize(t(id))}`
            : isOther
            ? getWords(t(id))
            : t("search")}
        </Typography>
        <Stack
          position="relative"
          direction="row"
          spacing={3}
          flexWrap="wrap"
          className="__feature__list"
        >
          {music.length > 0 ? (
            music.map((col, index) => (
              <MusicCard
                onStream={handleClick}
                isStreaming={id === "NowLive"}
                nftId={col.nftId}
                isNft={col.nftId ? true : false}
                isPlaylistNft={
                  (col.nftId && isPlaylist) || col?.channelName ? true : false
                }
                platform={col.platform}
                isPlaylist={
                  isPlaylist
                  // id === "playlists" ||
                  // history.location.pathname.includes("searchPlaylist") ||
                  // history.location.pathname.includes("MostTippedPlaylist") ||
                  // history.location.pathname.includes("MostStreamed") ||
                  // history.location.pathname.includes("NewReleasePlaylist") ||
                  // history.location.pathname.includes(
                  //   "MostStreamedTodayPlaylist"
                  // ) ||
                  // history.location.pathname.includes(
                  //   "MostStreamedThisWeekPlaylist"
                  // )
                  //   ? true
                  //   : false
                }
                isArtist={
                  id === "artists" ||
                  id === "users" ||
                  history.location.pathname.includes("searchArtist")
                    ? true
                    : false
                }
                music={col}
                key={index}
                isMusic={isMusic}
                isExplore={true}
                actions={
                  id === "artists" ||
                  id === "users" ||
                  history.location.pathname.includes("searchArtist")
                    ? [{ key: "m29", action: t("dropMenu.m29") }]
                    : isMusic
                    ? [
                        { key: "m2", action: t("dropMenu.m2") },
                        { key: "m3", action: t("dropMenu.m3") },
                        { key: "m1", action: t("dropMenu.m1") },
                      ]
                    : isOwner(
                        col["owner"] && typeof col["owner"] === "object"
                          ? col["owner"]["email"]
                          : col["createdByDetails"]
                          ? col["createdByDetails"]["email"]
                          : col["uploader"]
                          ? col["uploader"]["email"]
                          : ""
                      )
                    ? [
                        { key: "m26", action: t("dropMenu.m26") },
                        { key: "m27", action: t("dropMenu.m27") },
                        col["private"]
                          ? { key: "m5", action: t("dropMenu.m5") }
                          : { key: "m6", action: t("dropMenu.m6") },
                        // p["nftId"] ? "Sell NFT" : "",
                      ]
                    : [
                        { key: "m26", action: t("dropMenu.m26") },
                        { key: "m27", action: t("dropMenu.m27") },
                      ]
                }
                toggleMenu={(action, id) =>
                  toggleDrawer(action, col["_id"], index, col)
                }
                songIndex={id === "music" ? index : null}
                playSongs={(index) => {
                  if (id === "music") playSongs(music, index);
                }}
              />
            ))
          ) : (
            <NoData lable={t("noData.noData")} />
          )}
        </Stack>
      </Box>
      {loading ? <Loader message={message} /> : null}
      {showPlaylist ? (
        <AddMusicToPlaylist
          musicId={selectedId}
          open={showPlaylist}
          handleClose={() => setShowPlaylist(false)}
        />
      ) : null}
    </Box>
  );
}
